import {
    mapState,
} from 'vuex';

export default {
    name: 'MaskView',
    data() {
        return {};
    },
    computed: {
        ...mapState({
            // zindex: state => state.maskViewZindex,
        }),
    },
    mounted() {},
    methods: {
        closeAll() {
            this.$emit('hideMaskView');
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/maskView.js